import { render } from "./ValidationMessage.vue?vue&type=template&id=3e3038aa&scoped=true"
import script from "./ValidationMessage.vue?vue&type=script&lang=js"
export * from "./ValidationMessage.vue?vue&type=script&lang=js"

import "./ValidationMessage.vue?vue&type=style&index=0&id=3e3038aa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e3038aa"]])

export default __exports__